import { useTranslation } from 'react-i18next';
import { EmptyState } from '@ideoz/ui/components/molecules/EmptyState';

export function ArtifactsEmptyState(): JSX.Element {
  const { t } = useTranslation();
  return <EmptyState title={t('artifacts.emptyTitle')} description={t('artifacts.emptyDesc')} />;
}
